export default __webpack_public_path__ + "static/media/pxiByp8kv8JHgFVrLEj6Z1xlFQ.d4e54a87.woff2";